import { occFetch, occUrl } from "~/app/api/occ/occFetch";

interface DownloadUrlParams {
  selectionPath: string;
  partId: string;
  cadFormatId: number;
}

export async function fetchCadDownloadUrl(data: DownloadUrlParams): Promise<string> {
  const response = await occFetch(occUrl("/cad/downloadCadUrl"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.text();
}
